/* AURA Media Performance Engine 4.0 */
(() => {
  const stats = { images: 0, videos: 0, priority: 0 };

  const markShell = (el) => {
    const parent = el.closest('.aura-media4__shell') || el.parentElement;
    parent?.classList.add('is-loaded');
  };

  const upgradeImage = (img) => {
    if (img.dataset.auraMediaImg) return;
    img.dataset.auraMediaImg = 'true';
    stats.images++;

    if (!img.closest('.aura-media4__shell') && img.parentElement) {
      img.parentElement.classList.add('aura-media4__shell');
    }

    if (img.dataset.auraPriority === 'high') {
      img.setAttribute('fetchpriority', 'high');
      img.setAttribute('loading', 'eager');
      stats.priority++;
    } else if (!img.hasAttribute('loading')) {
      img.setAttribute('loading', 'lazy');
    }

    const done = () => {
      img.classList.add('is-loaded');
      markShell(img);
    };

    if (img.complete) done();
    else img.addEventListener('load', done, { once: true });
  };

  const upgradeVideo = (video) => {
    if (video.dataset.auraMediaVideo) return;
    video.dataset.auraMediaVideo = 'true';
    stats.videos++;

    if (!video.closest('.aura-media4__shell') && video.parentElement) {
      video.parentElement.classList.add('aura-media4__shell');
    }

    const sources = video.querySelectorAll('source[data-src]');
    if (sources.length && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          sources.forEach(source => {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
          });
          video.load();
          io.unobserve(video);
        });
      }, { rootMargin: '360px 0px' });
      io.observe(video);
    }

    if ('IntersectionObserver' in window) {
      const playIO = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            video.play?.().catch(()=>{});
          } else {
            video.pause?.();
          }
        });
      }, { threshold: .12 });
      playIO.observe(video);
    }

    const done = () => {
      video.classList.add('is-loaded');
      markShell(video);
    };

    if (video.readyState >= 2) done();
    else video.addEventListener('loadeddata', done, { once: true });
  };

  const init = (root = document) => {
    document.body?.classList.add('aura-media4');

    root.querySelectorAll('img').forEach(upgradeImage);
    root.querySelectorAll('video').forEach(upgradeVideo);

    window.AuraPerformance = window.AuraPerformance || { metrics: [] };
    window.AuraPerformance.metrics.push({
      name: 'media-engine',
      value: `${stats.images} images / ${stats.videos} videos`,
      time: Math.round(performance.now())
    });

    document.dispatchEvent(new CustomEvent('aura:media:ready', { detail: stats }));
  };

  if (window.AuraRegistry) {
    window.AuraRegistry.register('media-performance', 'body', () => init(document));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);

  document.addEventListener('shopify:section:load', e => init(e.target));
})();
